<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th id="BaiWidth" colspan="12" class="border-right">百位</th>
          <th id="ShiWidth" colspan="12" class="border-right">十位</th>
          <th colspan="12" class="border-right">个位</th>
          <th colspan="12" class="border-right">号码分布</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">大小形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">单双形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">质合形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">012形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">组三</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">组六</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">豹子</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">跨度</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">直选和值</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">和值尾数</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 4">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in opendNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
            <i class="ball-noraml">{{ Number(openNumbArr[index][0]) >= 5 ? '大' : '小' }}{{ Number(openNumbArr[index][1]) >= 5 ? '大' : '小' }}{{ Number(openNumbArr[index][2]) >= 5 ? '大' : '小' }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
            <i class="ball-noraml">{{ Number(openNumbArr[index][0]) % 2 == 0 ? '双' : '单' }}{{ Number(openNumbArr[index][1]) % 2 == 0 ? '双' : '单' }}{{ Number(openNumbArr[index][2]) % 2 == 0 ? '双' : '单' }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
            <i class="ball-noraml">{{ [1, 2, 3, 5, 7].includes(Number(openNumbArr[index][0])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(openNumbArr[index][1])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(openNumbArr[index][2])) ? '质' : '合' }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
            <i class="ball-noraml">{{ [0, 3, 6, 9].includes(Number(openNumbArr[index][0])) ? '0' : [1, 4, 7].includes(Number(openNumbArr[index][0])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(openNumbArr[index][1])) ? '0' : [1, 4, 7].includes(Number(openNumbArr[index][1])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(openNumbArr[index][2])) ? '0' : [1, 4, 7].includes(Number(openNumbArr[index][2])) ? '1' : '2' }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
            <i class="ball-noraml duizi" v-if="zusan[index] === 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ zusan[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
            <i class="ball-noraml duizi" v-if="zuliu[index] === 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ zuliu[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
            <i class="ball-noraml duizi" v-if="baozi[index] === 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ baozi[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
            <i class="ball-noraml">{{kuadu[index]}}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_red border-right">
            <i class="ball-noraml">{{ lotteryTrendTotalArr[index] }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai border-right">
            <i class="ball-noraml">{{ (lotteryTrendTotalArr[index]).toString().slice(-1) }}</i>
          </td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(total, sindex) in openNumStatisticaList.countArr" :key="sindex + 'total'">
            <i class="ball-noraml">{{ total }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zusan ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zuliu ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( baozi ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in openNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'lefta'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerb'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightc'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(zusan) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(zuliu) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(baozi) }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'left' + 'averageMiss1'" class="ball-none border-bottom"></td> 
          <td :key="i + 'center' + 'averageMiss2'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'right' + 'averageMiss3'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in openNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'left'" class="ball-none border-bottom"></td> 
          <td :key="i + 'center'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'right'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(zusan) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(zuliu) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(baozi) }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'left1'" class="ball-none border-bottom"></td> 
          <td :key="i + 'center2'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'right3'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in openNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'left' + 'empty1'" class="ball-none border-bottom"></td> 
          <td :key="i + 'center' + 'empty2'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'right' + 'empty3'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(zusan) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(zuliu) }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(baozi) }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'left' + 'maxContinuity1'" class="ball-none border-bottom"></td> 
          <td :key="i + 'center' + 'maxContinuity2'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'right' + 'maxContinuity3'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'Pl3Chart',
  mixins: [mix],
  computed: {

    zusan() {
      let arr = []
      let i = 1
      this.reverseOpenNumArr.forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] === numArr[1] && numArr[0] !== numArr[2])
          || (numArr[0] === numArr[2] && numArr[0] !== numArr[1])
          || (numArr[1] === numArr[2] && numArr[0] !== numArr[1])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    zuliu() {
      let arr = []
      let i = 1
      this.reverseOpenNumArr.forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] !== numArr[1])
          && (numArr[0] !== numArr[2])
          && (numArr[1] !== numArr[2])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    baozi() {
      let arr = []
      let i = 1
      this.reverseOpenNumArr.forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] === numArr[1])
          && (numArr[0] === numArr[2])
          && (numArr[1] === numArr[2])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    kuadu() {
      let arr = []
      this.reverseOpenNumArr.forEach((numArr, index) => {
        const max = Math.max(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]))
        const min = Math.min(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]))
        arr[index] = max - min
      })
      return arr.reverse()
    }
  },
  mounted() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      console.log(69999999999999);
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas();
        }, 0);
      });
    });
  },
  methods: {
    getArrayChartCoordinate(Coordinate) {
        if (!this.$refs.drawnumbHead) return [];
        let chartCoordinate = [];

        Coordinate.forEach((trendList, trendIndex) => {
          //获取坐标系
          let len = trendList.length;
          console.log('len', len)
          if (len == 0) return [];

          //先获取表格左边不需要折线部分的宽度
          let dwidth = this.$refs.drawnumbHead.offsetWidth;
          let pwidth = this.$refs.periodsHead.offsetWidth;
          //左边总宽度
          let leftCountWidth = dwidth + pwidth;
          //上边总高度
          let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
          //表格td宽度 表格td高度
          if(!document.getElementById("smallRect")) {
            return;
          }
          const tdWidth = document.getElementById("smallRect").offsetWidth;
          const tdHeight = document.getElementById("smallRect").offsetHeight;
          const BaiWidth = document.getElementById("BaiWidth").offsetWidth;
          const ShiWidth = document.getElementById("ShiWidth").offsetWidth;
          // //万位 千位 这些大格子的宽度
          // let tableThWidth = tdWidth * this.lotteryNumbHead.length + BaiWidth + tdRightWidth;
          // console.log('大格子宽度', tableThWidth, tdWidth, tdLeftWidth, tdRightWidth)

          let list = [];

          for (let i = 0; i < len; i++) {
            let numb = Number(this.lotteryNumbHead[trendList[i].indexOf("A")]);
            let index = this.lotteryNumbHead.indexOf(numb);
            let x = 0
            if(trendIndex === 0) {
              x = leftCountWidth + (tdWidth * index + ( tdWidth / 2)) + 5;
            } else if(trendIndex === 1) {
              x = leftCountWidth + (tdWidth * index + ( tdWidth / 2)) + BaiWidth + 5
            } else if(trendIndex === 2) {
              x = leftCountWidth + (tdWidth * index + ( tdWidth / 2)) + BaiWidth + ShiWidth + 6
            }
            let y = topCountWidth + (tdHeight * i + tdHeight / 2);
            list.push([x, y]);
          }
          chartCoordinate.push(list);
        });

        return chartCoordinate;
      },
  }
}
</script>

<style>

</style>